import { useAllTikTokUserStats } from '@round/platforms/tiktok';
import PerformanceChart, { Item } from './PerformanceChart';
import {
    AVG_VIDEO_PLAYS_COLOR,
    FOLLOWERS_COLOR,
    LIKES_COLOR,
    getLatestStatsOnEachDay,
    sortFromOldToRecent,
    filterWithinDateRange,
} from './helpers';
import styles from './Performance.module.css';
import { DateRange } from '@round/creatorbase-ui';

type Props = {
    userId: number | null | undefined;
    isLoading?: boolean;
    dateRange?: DateRange;
};

const TikTokPerformance = ({ userId, dateRange }: Props) => {
    const { data } = useAllTikTokUserStats(
        { user_ids: typeof userId === 'number' ? [userId] : [] },
        { enabled: !!userId }
    );

    // stats can have multiple entries for the same day, so we need to keep only the latest one
    const stats = sortFromOldToRecent(filterWithinDateRange(getLatestStatsOnEachDay(data ?? []), dateRange));

    const followers: Item[] = stats.map((el) => ({
        timestamp: el.timestamp,
        value: el.follower_count,
    }));

    const likes: Item[] = stats.map((el) => ({
        timestamp: el.timestamp,
        value: el.heart,
    }));

    const avgVideoPlays: Item[] = [];

    return (
        <div className={styles.container}>
            <PerformanceChart data={followers} label="Total Followers" color={FOLLOWERS_COLOR} />
            <PerformanceChart data={likes} label="Total Likes" color={LIKES_COLOR} />
            <PerformanceChart data={avgVideoPlays} label="Avg. video plays" color={AVG_VIDEO_PLAYS_COLOR} />
        </div>
    );
};

export default TikTokPerformance;
